<script setup lang="ts">
import type { TFileImageSource } from '@/composables/files/useFileImage';
import FileImage from '@/core/files/FileImage.vue';

defineProps<{
  imageSource?: TFileImageSource;
  interactive?: boolean;
}>();
const emit = defineEmits<{ click: [event: MouseEvent] }>();
</script>

<template>
  <component
    :is="interactive ? 'button' : 'div'"
    v-if="imageSource"
    :type="interactive ? 'button' : undefined"
    class="block aspect-square appearance-none border-0 p-0"
    @click="interactive && emit('click', $event)"
  >
    <FileImage :source="imageSource" alt="" placeholder-size="sm" class="size-full object-cover" />
  </component>
</template>
